import { ApiResult, apiUrl } from '../../../api';
import { getAccessToken } from '../../../store/authEffect';
import {
  ZendeskHelpCenterSearchRequest,
  ZendeskRequest,
  PrioHealthStatus,
} from '../../../models/Zendesk';
import fetchWithRetry from '../../../util/fetchWithRetry';
import {
  ContentDto,
  FaqDto,
  ReleaseDto,
} from '../../../models/Prio365Features';

export const apiSearchZendeskResults: (
  searchString: string,
  locale?: string
) => Promise<ApiResult<ZendeskHelpCenterSearchRequest>> = async (
  searchString,
  locale
) => {
  const result = await fetchWithRetry(
    `${apiUrl}/support/support/prioHelp?query=${searchString}`,
    {
      headers: {
        Authorization: `Bearer ${await getAccessToken()}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }
  );

  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};

export const apiZendeskRequest: (
  request: ZendeskRequest
) => Promise<boolean> = async (request) => {
  const result = await fetchWithRetry(`${apiUrl}/support/Support/me/request`, {
    headers: {
      Authorization: `Bearer ${await getAccessToken()}`,
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(request),
  });

  return result.status >= 200 && result.status < 300;
};

export const apiZendeskAttachmentUploadUrl: () => string = () =>
  `${apiUrl}/support/Support/attachment`;

export const apiZendeskDeleteAttachment: (
  attachmentToken: string
) => Promise<boolean> = async (attachmentToken) => {
  const result = await fetchWithRetry(
    `${apiUrl}/support/Support/attachment/${attachmentToken}`,
    {
      headers: {
        Authorization: `Bearer ${await getAccessToken()}`,
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    }
  );

  return result.status >= 200 && result.status < 300;
};

export const apiHelpGetReleases: () => Promise<
  ApiResult<ReleaseDto[]>
> = async () => {
  const result = await fetchWithRetry(`${apiUrl}/support/Help/releases`, {
    headers: {
      Authorization: `Bearer ${await getAccessToken()}`,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};

// NEW: Get release content by version using new Help controller
export const apiHelpGetReleaseContent: (
  version: string
) => Promise<ApiResult<ContentDto[]>> = async (version) => {
  const result = await fetchWithRetry(
    `${apiUrl}/support/Help/releases/${encodeURIComponent(version)}/content`,
    {
      headers: {
        Authorization: `Bearer ${await getAccessToken()}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }
  );

  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};

// NEW: Get FAQs using new Help controller
export const apiHelpGetFaqs: () => Promise<ApiResult<FaqDto[]>> = async () => {
  const result = await fetchWithRetry(`${apiUrl}/support/Help/faq`, {
    headers: {
      Authorization: `Bearer ${await getAccessToken()}`,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};

export const apiFetchPrioHealthStatus: () => Promise<
  ApiResult<PrioHealthStatus[]>
> = async () => {
  const result = await fetchWithRetry(`${apiUrl}/priohealth/prioHealthStatus`, {
    headers: {
      Authorization: `Bearer ${await getAccessToken()}`,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};
